module.exports = __webpack_public_path__ + "a768e7de/img/delete-icon.eb7de062.svg";